import type {
  DefaultViewFeature,
  DefaultViewFeatureRoutePath,
} from 'src/types/route';

export const HOME_PAGE_DEFAULT_VIEW_FEATURES: DefaultViewFeature[] = [
  {
    defaultViewKey: 'measuredDataMap',
    fieldConfigKey: 'dataMapIsEnabled',
    tableHeader: 'Data map',
    title: 'Measured data map',
    route: '/$field/measured-data/map',
  },
  {
    defaultViewKey: 'linePlot',
    fieldConfigKey: 'linePlotIsEnabled',
    tableHeader: 'Line plot',
    title: 'Pressure data line plot',
    route: '/$field/measured-data/plot',
  },
  {
    defaultViewKey: 'prognosis',
    fieldConfigKey: 'prognosisIsEnabled',
    tableHeader: 'Prognosis',
    title: 'Pressure prognosis',
    route: '/$field/prognosis/dashboard',
  },
];

export const DEFAULT_VIEW_FALLBACK_ROUTE: DefaultViewFeatureRoutePath =
  '/$field/prognosis/dashboard';
